var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-icon",class:{
    hoverable: _vm.hoverable,
    'text-gray-dark-2': !_vm.iconComponent,
    'app-icon-reverse': _vm.reverse,
  },style:({ '--icon-color': _vm.colors[_vm.hoverColor] || _vm.hoverColor })},[_c(_vm.iconComponent || 'none',_vm._g({tag:"component",attrs:{"height":_vm.size,"width":_vm.size}},_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }